//* Components
import Text from '@/components/common/Text';
import Image from '@/components/common/Image';
import Editor from '@/components/common/Editor';

//* Style
import CategoryDescriptionSectionStyle from './style';

const CategoryDescriptionSection = ({ name, description, image }) => {
	return (
		<CategoryDescriptionSectionStyle>
			<div className='catalog-wrapper'>
				<div className='catalogWrapperDescription'>
					<div className='catalogDescription'>
						<Text className={'h1-L font-futura-medium'}>{name}</Text>

						<Editor data={description} />
					</div>

					<Image
						src={image.src}
						alt={image.alt}
						className={'catalog-image'}
					/>
				</div>
			</div>
		</CategoryDescriptionSectionStyle>
	);
};

export default CategoryDescriptionSection;
